import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'

import routes from '../common/routes'
import PendingNavDataLoader from './components/pendingNavDataLoader'

export default ({
  store
}) => (
  <Provider store={store}>
    <BrowserRouter>
      <PendingNavDataLoader store={store} routes={routes}>
        {renderRoutes(routes)}
      </PendingNavDataLoader>
    </BrowserRouter>
  </Provider>
)



// WEBPACK FOOTER //
// ./client/app.js